import React, { useEffect, useState } from "react";
import ijcaps1 from '../assets/images/ijcaps1.webp';
import ijcaps2 from '../assets/images/ijcaps2.webp';
import ijcaps3 from '../assets/images/ijcaps3.webp';
import AOS from "aos";
import 'aos/dist/aos.css';
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/Config";
import Spinner from "react-activity/dist/Spinner";
import { useNavigate } from "react-router-dom";


const Ijcapsociety = () => {
    const [showloading, setshowloding] = useState(false);
        const [fetcheddata, setfetcheddata] = useState([]);
        const navigate = useNavigate();

        const fetchcommiteedata = async() => {
            setshowloding(true);
            const headers = {
                headers: {
                  "Content-Type": "application/json",
                },
              };
              let resp = await axios
              .get(apiUrl + "getuserijcapsociety", headers)
              .then((res) => {
                if (res.data.status == "success" && res?.data?.data?.length > 0) {
                    setfetcheddata(res?.data?.data)
                    setshowloding(false);
                } else {
                    setfetcheddata([])
                    setshowloding(false);
                }
              })
              setshowloding(false);
    
        }

        const handleclickjournal = (journal) => {
            if(journal) {
                // navigate(assetsUrl+'ijcapjournals/'+journal);
                window.open(assetsUrl + 'ijcapjournals/' + journal, '_blank');
            }
        }
        useEffect(() => {
                        AOS.init();
                        AOS.refresh();
                        fetchcommiteedata();
                    }, [])
    return (
        <div>
            <section className="gallery-main-section">
                <div className="text-center about-tiilte-sec">
                    <p className="about-tiilte-sec-head">IJCAP Society</p>
                    <p className="about-tiilte-sec-subhead"> home <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i>
                        IJCAP Society</p>
                </div>
            </section>

            <section className="ijcap-content">
                <div className="container">
                    <div className="ijcap-socity-content">
                        <p className="ijcap-heading">Indian Journal of Clinical Anatomy and Physiology (IJCAP) Society</p>
                        <p className="ijcap-para">IJCAP is a prestigious platform that fosters innovation and research in the dynamic fields of clinical anatomy and physiology, encouraging the exchange of knowledge among researchers, academicians, and practitioners.</p>
                    </div>

                    <div className="ijcap-socity-content">
                        <p className="ijcap-heading">About IJCAP</p>
                        <p className="ijcap-para">The Indian Journal of Clinical Anatomy and Physiology is a peer-reviewed journal dedicated to advancing understanding in clinical anatomy, human physiology, and related biomedical sciences. The journal aims to bridge the gap between basic research and clinical application, providing valuable insights that contribute to the scientific and medical communities. <br /> <br />

                            As an official publication affiliated with SVU Zoology Alumni, IJCAP serves as a platform for the dissemination of groundbreaking research, offering an opportunity for alumni, faculty, and students to showcase their work and contribute to the field’s growing body of knowledge.  </p> </div>


                    <div className="ijcap-socity-content">
                        <p className="ijcap-heading">What We Publish</p>
                        <p className="ijcap-para">The journal welcomes high-quality research articles, review papers, case studies, and short communications on topics including but not limited to:</p>
                        <div className="ijcap-socity-check-iconcontent">

                            <i class="fa fa-check   ijcap-socity-check-icon " aria-hidden="true"></i><p className="ijcap-para">Comparative and human anatomy.</p></div>
                        <div className="ijcap-socity-check-iconcontent"> <i class="fa fa-check   ijcap-socity-check-icon " aria-hidden="true"></i><p className="ijcap-para">Advances in clinical and physiological research.</p>

                        </div>
                        <div className="ijcap-socity-check-iconcontent">  <i class="fa fa-check   ijcap-socity-check-icon " aria-hidden="true"></i><p className="ijcap-para">Innovative techniques in anatomical education.</p>
                        </div>
                        <div className="ijcap-socity-check-iconcontent"> <i class="fa fa-check   ijcap-socity-check-icon " aria-hidden="true"></i><p className="ijcap-para">Physiological applications in clinical practice.</p>
                        </div>
                        <div className="ijcap-socity-check-iconcontent"><i class="fa fa-check   ijcap-socity-check-icon " aria-hidden="true"></i><p className="ijcap-para">Research on diagnostic methods and therapeutic interventions.</p>
                        </div>

                        <div className="ijcap-socity-check-iconcontent"><i class="fa fa-check   ijcap-socity-check-icon " aria-hidden="true"></i><p className="ijcap-para">Biomedical technologies and their applications.</p>
                        </div>
                    </div>
                    <div className="ijcap-socity-content">
                        <p className="ijcap-heading">Browse Published Papers</p>
                        <p className="ijcap-para">Discover insightful research by browsing the IJCAP Paper Repository, which features articles submitted by our esteemed alumni and members of the IJCAP Society. These publications embody excellence in research and reflect the innovative spirit of our contributors. </p> </div>



                </div>
            </section>

            <section className="ijcapsociety-papersec">
                <div className="container">
                    <div className="row">

                    {
                            fetcheddata?.length > 0 ?
                            fetcheddata?.map((item, index) => {
                                return (
                                    <div className="col-12 col-md-6 col-lg-4 mb-2 mb-md-4" data-aos="fade-up" data-aos-delay="300" data-aos-duration="300" 
                                    key={index}
                                    onClick={() => {handleclickjournal(item?.journal)}}
                                    >
                                    <div className="app-container">
                                        <div className="hover-image-container">
                                            <img src={assetsUrl+"ijcapsociety/"+item?.image} alt="Image" className="hover-image" />
                                            <div className="social-overlay">
                                            </div>
                                        </div>
                                    </div>
                                    <p className="alumini-comitee-member-name">{item?.name}</p>
                                </div>
                                );
                            }) :
                            showloading ?
                            <div>
                                 <Spinner color='#264790' size={22} className='spinnerCenter' />
                            </div>
                            :
                            <p className="alumini-comitee-member-name" style={{textAlign: 'center'}}></p>
                        }

                       
                        
                    </div>
                </div>
            </section>
        </div>
    )
}
export default Ijcapsociety;